import styled from 'styled-components';
import { THEME_COLORS } from '../../styles/theme';
import { FontFamilyRegular, FontSize16  } from '../fonts';
import { size } from '../media-queries';

export const Button = styled.div`
    align-items: center;
    background:${props=> props.active ? 
        props.theme.color[THEME_COLORS.greenBlueReversed] : props.theme.color[THEME_COLORS.white]};
    
    border: 2px solid ${props => props.theme.color.green};
    border-radius: 35px;
    color: ${props=> props.active ? 
        "#fff" : "black"};
    display: flex;
    flex-direction: column;
    height: 170px;
    justify-content: ${props => props.hasCheckbox ? 'flex-end' : 'center'};
    margin-right: 20px;
    width: 140px;
    -webkit-touch-callout: none; 
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none;
    -ms-user-select: none; 
    user-select: none; 
    ${props=> props.active ? `& * {
        stroke: white;
    }` : `` };
    
    min-width: 140px;
    @media (min-width: ${size.tablet}) {
        width: 170px;
    }
`
export const Label = styled.span`
    ${FontFamilyRegular};
    ${FontSize16};
    text-align: center;
    max-width: 125px;
`

export const IconContainer = styled.div`
    margin-bottom: 14px;
`;

export const BigButtonCheckbox = styled.div`
    width: 24px;
    height: 24px;
    border: solid 2px ${props => props.isActive ? props.theme.color.white : props.theme.color.darkBlue};
    position: relative;
    margin-bottom: 8px;
    margin-top: 8px;
`;

export const BigButtonCheckboxSquare = styled.div`
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: ${props => props.isActive ? props.theme.color.white : 'transparent'};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) ${props => props.isActive ? 'scale(1)' : 'scale(0)'};
    transition: transform 0.2s ease-in-out;
`;